import React from 'react';

const HowItWorks: React.FC = () => {
  return (
    <section className="how-it-works">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">How Traveze Works</h2>
          <p className="section-subtitle">
            Transform your travel dreams into reality with our simple 3-step process
          </p>
        </div>
        <div className="steps-grid">
          <div className="step-card">
            <div className="step-number">1</div>
            <h3 className="step-title">Share Your Preferences</h3>
            <p className="step-description">
              Tell us about your travel style, budget, interests, and destination dreams
            </p>
          </div>
          <div className="step-card">
            <div className="step-number">2</div>
            <h3 className="step-title">AI Generates Your Plan</h3>
            <p className="step-description">
              Our smart AI creates a personalized itinerary based on your unique preferences
            </p>
          </div>
          <div className="step-card">
            <div className="step-number">3</div>
            <h3 className="step-title">Customize & Book</h3>
            <p className="step-description">
              Review, adjust, and book your perfect travel experience with just a few clicks
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks; 